export default {
  TODO: {
    key: "TODO",
  },
  DONE: {
    key: "DONE",
  },
};
